<template>
  <div class="section">
    <div class="container">
      <h1>Period Manager</h1>
      <div class="columns is-multiline">
        <div class="column is-5">
          <b-input type="text" v-model="filter" placeholder="Filter Periods"></b-input>
        </div>
        <div class="column is-7">
          <b-button class="is-primary is-pulled-right" @click="addPeriod">Add Period</b-button>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table :data="filteredPeriods"
                   hoverable
                   mobile-cards
                   paginated
                   default-sort-direction="desc"
                   default-sort="Created"
                   :loading="loading"
                   :per-page="10"
                   pagination-simple>
            <b-table-column field="Name" label="Name" sortable v-slot="props">
              {{ props.row.Name }}
            </b-table-column>
            <b-table-column field="Created" label="Created" sortable v-slot="props">
              {{props.row.Created | utc | moment('MM/DD/YYYY')}}
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import addPeriod from "@/components/modals/addPeriod.vue";
  export default {
    data() {
      return {
        filter: '',
        periods: [],
        loading: false
      }
    },
    async created() {
      await this.refreshPeriods();
    },
    methods: {
      async refreshPeriods() {
        this.loading = true;
        await this.$http.get("api/period")
          .then(resp => {
            this.periods = resp.data;
            this.loading = false;
          }).catch(err => {
            console.error(err);
            this.loading = false;
          });
      },
      addPeriod() {
        this.$buefy.modal.open({
          component: addPeriod,
          events: {
            close: () => { this.refreshPeriods(); },
            refresh: () => {
              this.refreshPeriods();
            }
          }
        });
      }
    },
    computed: {
      filteredPeriods() {
        return this.periods.filter((option) => {
          if (option.Created.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Created
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.Name.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Name
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          }
        });
      }
    }
  }
</script>
